import {
    initializeUpNextEventLoader,
    refreshUpNextCalendarEventForAllScenarios,
} from 'owa-upnext-event-loader';
import { getSelectedCalendarsFlatList } from 'owa-calendar-module-selected-calendars-user-config';
import { getLockId } from '../selectors/getLockId';

export function initializeEventsNow() {
    const selectedCalendars = getSelectedCalendarsFlatList();

    initializeUpNextEventLoader(selectedCalendars, getLockId());
    refreshUpNextCalendarEventForAllScenarios();
}
